<script setup lang="ts">
import {
  computed,
  getCurrentInstance,
  useAttrs,
  defineProps,
  defineEmits,
} from 'vue'
import CUSkeletonLoaderCheckbox from '@/components/CUSkeletonLoaderCheckbox.vue'

defineProps<{
  skeletonLoader?: boolean
  labelWidth?: string
  value?: boolean
}>()

const emit = defineEmits<{
  (e: 'input', value: boolean): void
  (e: 'change', value: boolean): void
}>()

const attrs = useAttrs()
const instance = getCurrentInstance()

// class/style are not in attrs — forward onto v-checkbox so utilities like
// margin-t-0 override Vuetify's .v-input--selection-controls { margin-top: 16px }
const checkboxClass = computed(() => {
  const data = instance?.proxy?.$vnode?.data
  if (!data) return undefined
  return [data.staticClass, data.class]
})

const listeners = computed(() => {
  return {
    ...attrs,
    // v-checkbox model event is `change` (inputValue); also emit `input` for v-model
    change: (event: boolean) => {
      emit('change', event)
      emit('input', event)
    },
    input: (event: boolean) => {
      emit('input', event)
    },
  }
})

const hideDetails = computed(
  () => !!(attrs['hide-details'] ?? attrs.hideDetails)
)
</script>

<template>
  <div class="cu-checkbox">
    <CUSkeletonLoaderCheckbox
      v-if="skeletonLoader"
      :label-width="labelWidth"
      :hide-details="hideDetails"
    />
    <v-checkbox
      v-else
      :class="checkboxClass"
      v-bind="attrs"
      :input-value="value"
      v-on="listeners"
    />
  </div>
</template>
